import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/yujian_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Editor from "../../../components/Editor";
export default {
  components: {
    Editor: Editor
  },
  data: function data() {
    return {
      form: {
        id: "",
        title: "",
        language: "",
        year: "",
        content: "",
        status: 1
      },
      iconfileList: [],
      picfileList: [],
      rules: {
        title: [{
          required: true,
          message: "请输入标题",
          trigger: "blur"
        }],
        language: [{
          required: true,
          message: "请选择语言",
          trigger: "blur"
        }],
        year: [{
          required: true,
          message: "请选择年份",
          trigger: "blur"
        }],
        content: [{
          required: true,
          message: "请输入内容",
          trigger: "blur"
        }],
        status: [{
          required: true,
          message: "请选择状态",
          trigger: "blur"
        }]
      }
    };
  },
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$refs.newPopover.open();

                if (data) {
                  _this.form = {
                    id: data.id,
                    title: data.title,
                    language: data.language,
                    year: data.year,
                    content: data.content,
                    status: data.status
                  };
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    picUrl: function picUrl(e) {
      this.picfileList = e;
      this.form.pic = e.toString();
    },
    clearData: function clearData(id) {
      this.form = {
        id: id,
        game_news_type_id: "",
        title: "",
        pic: "",
        content: "",
        status: 1
      };
      this.$refs.ruleForm.resetFields();
    },
    submitData: function submitData() {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var reqFn = _this2.form.id ? 'updBusinessInfo' : 'addBusinessInfo';

          _this2.$api[reqFn](_this2.form).then(function (res) {
            if (res.code == 0) {
              _this2.$message({
                message: '操作成功',
                type: 'success'
              });

              _this2.$refs.newPopover.hide();

              _this2.$emit('change');
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};